import clsx from "clsx";
import { ArrowIcon, CloseIcon, InfoIcon } from "./icons";

const variationClasses = {
  rating: ["button--filled", "button--pill"],
};

export function Button({
  children,
  icon,
  iconPrev,
  iconNext,
  iconInfo,
  iconClose,
  srText,
  onClick,
  disabled,
  className,
  variation,
  type = "button",
  ...props
}) {
  return (
    <button
      type={type}
      className={clsx(
        "button",
        variation && (variationClasses[variation] || `button--${variation}`),
        className,
      )}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon}
      {iconInfo && <InfoIcon />}
      {iconClose && <CloseIcon />}
      {iconPrev && <ArrowIcon direction="start" />}
      {children && (
        <span className={srText ? "sr-only" : undefined}>{children}</span>
      )}
      {iconNext && <ArrowIcon direction="end" />}
    </button>
  );
}
